<template>
  <div class="form-input">
    <input
      ref="inputRef"
      :type="type"
      v-model="model"
      v-bind="$attrs"
      @input="onInput"
      @keyup="onKeyUp"
      @change="onChange"
      @focus="hasFocus = true"
      @blur="hasFocus = false"
    />

    <button
      class="form-input__clear"
      aria-label="Wissen"
      @click="clearInput"
      @mousedown="clearInput"
      @keydown.space.enter="clearInput"
      v-show="clearable && model !== ''"
    >
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon dp__input_icons" data-test="clear-icon"><path d="M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"></path><path d="M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"></path></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "FormInput",
  inheritAttrs: false,
  emits: ["input", "change", "update:value", "keyup"],
  components: {},

  props: {
    type: {type: String, default: "text"},
    value: {required: true},
    clearable: {type: Boolean, default: false},
  },

  data() {
    return {
      model: this.value || "",
      hasFocus: false,
      hasValue: false
    }
  },

  watch: {
    "value"(to, from) {
      if (to !== from) {
        this.model = to
      }
    },
  },

  methods: {
    clearInput(e) {
      this.model = ""
      this.$refs["inputRef"].focus()

      this.$emit("change", this.model)
    },
    onChange(e) {
      this.$emit("change", this.model)
    },
    onKeyUp(e) {
      this.$emit("keyup", e)
    },
    onInput(e) {
      this.$emit("input", this.model)
    },
  }
};
</script>
